// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3Xr91","container":"styles_container__25dZQ","image":"styles_image__2z0BI","text":"styles_text__LIBVD"};